<template>
  <div style="height: 50px">
    <v-card color="#1b5e20" class="mx-auto">
      <v-row>
        <v-col cols="12" md="12">
          <v-list subheader color="#1b5e20" style="height: 50px">
            <v-list-item>
              <v-avatar color="white" style="background-color: #1b5e20" size="80">
                <img
                  :src="getImage('/' + setting.logo_path_url)"
                  height="100px"
                  width="100px"
                  contain
                  v-if="!guest"
                />
                <img src="/img/unavailable.png" v-if="guest" />
              </v-avatar>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                :to="item.route"
                style="display: none"
              >
                <v-card-text class="text-center">
                  <v-btn
                    icon
                    rounded
                    color="green"
                    style="background-color: white"
                    outlined
                    elevation="5"
                    large
                  >
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-btn>
                  <v-list-item-title align="center" class="mt-3 caption">
                    {{ item.text }}
                  </v-list-item-title>
                </v-card-text>
              </v-list-item>
              <v-card-text class="text-center">
                <v-btn
                  @click="admin"
                  icon
                  rounded
                  color="green"
                  style="background-color: white"
                  outlined
                  elevation="5"
                >
                  <v-icon>fas fa-laptop</v-icon>
                </v-btn>
                <v-list-item-title
                  align="center"
                  class="mt-3 caption"
                  style="display: none"
                >
                  Admin
                </v-list-item-title>
              </v-card-text>

              <v-card-text class="text-center" v-if="!guest">
                <v-btn
                  @click="refreshData"
                  icon
                  rounded
                  color="green"
                  style="background-color: white"
                  outlined
                  elevation="5"
                >
                  <v-icon>fas fa-refresh</v-icon>
                </v-btn>
                <v-list-item-title
                  align="center"
                  class="mt-3 caption"
                  style="display: none"
                >
                  Refresh Data
                </v-list-item-title>
              </v-card-text>
              <v-card-text class="text-center" v-if="guest">
                <v-btn
                  @click="login"
                  icon
                  rounded
                  color="green"
                  style="background-color: white"
                  outlined
                  elevation="5"
                >
                  <v-icon>fas fa-sign-in-alt</v-icon>
                </v-btn>
                <v-list-item-title
                  align="center"
                  class="mt-3 caption"
                  style="display: none"
                >
                  Login
                </v-list-item-title>
              </v-card-text>
              <v-card-text class="text-center" v-if="!guest">
                <v-btn
                  @click="logout"
                  icon
                  rounded
                  color="green"
                  style="background-color: white"
                  outlined
                  elevation="5"
                >
                  <v-icon>fas fa-sign-out-alt</v-icon>
                </v-btn>
                <v-list-item-title
                  align="center"
                  class="mt-3 caption"
                  style="display: none"
                >
                  Logout
                </v-list-item-title>
              </v-card-text>
              <v-avatar
                color="white"
                style="background-color: #1b5e20"
                size="80"
                v-if="!guest"
                class="hidden-sm-and-down"
              >
                <v-img :src="getImage('/' + user.avatar)" x-large></v-img>
              </v-avatar>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    selectedItem: 0,
    drawer: null,
    items: [
      { icon: "fas fa-laptop", text: "Admin", route: "/admin", auth: true },
      // { icon: 'far fa-bell', text: 'Info' },
    ],
    attrs: {
      class: "mb-6",
      boilerplate: true,
      elevation: 2,
    },
  }),
  methods: {
    ...mapActions({
      setDialogStatus: "dialog/setStatus",
      setDialogComponent: "dialog/setComponent",
      setAuth: "auth/set",
      setAlert: "alert/set",
      setSetting: "setting/set",
      setFlatform: "flatform/set",
    }),
    admin() {
      return this.$router.push({ path: "/admin", auth: true });
    },
    refreshData() {
      window.location.reload();
    },
    login() {
      return this.$router.push({ path: "/login" });
    },
    logout() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/logout", {}, config)
        .then(() => {
          this.setAuth({});
          this.setAlert({
            status: true,
            color: "success",
            text: "Logout successfully",
          });
          this.setFlatform(null);
        })
        .catch((error) => {
          let { data } = error.response;
          this.setAlert({
            status: true,
            color: "error",
            text: data.message,
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      countCart: "cart/count",
      guest: "auth/guest",
      user: "auth/user",
      dialogStatus: "dialog/status",
      currentComponent: "dialog/component",
      setting: "setting/setting",
      flatform: "flatform/flatform",
    }),
    dialog: {
      get() {
        return this.dialogStatus;
      },
      set(value) {
        this.setDialogStatus(value);
      },
    },
  },
};
</script>
